import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'

import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent, DialogContentText,
  DialogTitle, IconButton, Switch, TextField, Typography
} from '@material-ui/core'
import styles from './EventTransactionsTable.module.css'
import axios from "axios";
import {
  Grid,
  InputLabel, Theme,
} from "@mui/material";
import {useEventState} from "../../slices/eventSlice";
import styled from "@emotion/styled";
import {formatMoney} from "../../util/formatHelpers";
import {Add, Edit} from "@material-ui/icons";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {Menu, MenuItem} from "@mui/material";
import {DataGridPremium, GridCellParams, GridRowParams} from "@mui/x-data-grid-premium";
import {useQueryClient} from "react-query";
import dayjs from "dayjs";
import {GenericForm} from "../GenericForm/GenericForm";
import clsx from "clsx";

interface FormData {
  id: number
  paymentmethod: string
  additionaldonation: number
  discount: number
}

export const Input = styled("input")`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  height: 60px;
  border-radius: 10px;
  background-color: #e0ebf180;
  outline: none;
  border: 1px solid #66666660;
  padding-left: 15px;
  ::placeholder {
    font-size: 14px;
    padding-left: 0px;
  }
`;

const Span = styled.span`
  padding-left: 0.5em;
`

export const EventCheckoutReview = ({ isOpen, setIsOpen, eventId, transactionid, setTransactionId, setItemQuantity, canVoid = false, onCartExpired = (_msg: string) => {} }) => {
  const queryClient = useQueryClient()
  const formMethods = useForm<FormData>()
  const eventState = useEventState()
  const title = "Review Transaction"
  const { setValue, watch, getValues, setError, clearErrors, setFocus } = formMethods
  const { reset } = formMethods
  const [dialogMsg, setDialogMsg] = React.useState("")
  const [voidDialog, setVoidDialog] = React.useState({open: false, transactionid: null, ticketid: null})
  const [kebabAnchor, setKebabAnchor] = React.useState<null | HTMLElement>(null)
  const [voidTransactionConfirm, setVoidTransactionConfirm] = React.useState(false)
  const [voidReason, setVoidReason] = React.useState("")
  const [voidTicketReason, setVoidTicketReason] = React.useState("")
  const [loading, setLoading] = React.useState(false)
  const [isGuestOpen, setIsGuestOpen] = React.useState(false);
  const [dialogObj, setDialogObj] = React.useState({ msg: "", id: 0 })
  const [ticketList, setTicketList] = React.useState([])
  const [ticketId, setTicketId] = React.useState(0)
  const [isVoided, setIsVoided] = React.useState(false)
  const [voidedBy, setVoidedBy] = React.useState('')
  const [voidedDate, setVoidedDate] = React.useState('')
  const [voidedComment, setVoidedComment] = React.useState('')

  const [setupData, setSetupData] = React.useState({})
  const [transactionData, setTransactionData] = React.useState({
    // transactionid: 0,
    transactiontotalamount: 0,
    transactionpaymentmethod: '',
    transactionadditionaldonation: 0,
    transactionaddress: '',
    transactionaddress2: '',
    transactioncity: '',
    transactioncountry: '',
    transactiondate: '',
    transactiondiscountamount: 0,
    transactionemail: '',
    transactionfirst: '',
    transactionlast: '',
    transactionphone: '',
    transactionprocessingfees: 0,
    transactionsource: '',
    transactionstate: '',
    transactionsubtotal: 0,
    transactionzip: '',
    itemdetail: [],
    ticketlist: [],
    transactionisvoided: false,
    transactionvoidedby: '',
    transactionvoideddate: '',
    transactionvoidedcomment: '',
  })

  useEffect(() => {
    getTransactionData(true)
  }, [isOpen])

  useEffect(() => {
    getTransactionData(false)
  }, [isGuestOpen])

  const getTransactionData = async (updateTransData) => {
    if (eventId > 0 && transactionid > 0) {
      setLoading(true)
      const { data } = await axios.post('/evtactivitytransactions', {eventid: eventId, transactionid: transactionid})
      const parsedData = JSON.parse(data.jsonString)
      setLoading(false)

      if (parsedData.status === 'expired') {
        setIsOpen(false)
        onCartExpired(parsedData.message || 'Cart Expired')
        return
      }

      const voidedItem = parsedData.itemdetail?.find(item => item.transactionisvoided)
      setIsVoided(Boolean(voidedItem))
      setVoidedBy(voidedItem?.transactionvoidedby || '')
      setVoidedDate('')
      setVoidedComment(voidedItem?.transactionvoidedcomment || '')

      if (updateTransData) {
        setTransactionData(parsedData)
      }

      const newTicketList = parsedData?.ticketlist?.map(ticket => {
        return {guestname: ticket.guestname, groupname: ticket.groupname, ticket: ticket.ticket, ticketid: ticket.ticketid, id: ticket.ticketid, transactionid: ticket.transactionid, ticketcanremove: ticket.ticketcanremove, ticketremovedcomment: ticket.ticketremovedcomment}
      })
      setTicketList(newTicketList)
    }
  }

  const onSubmit = async () => {
      queryClient.invalidateQueries(['EventTransaction', Number(eventId)])

      setItemQuantity({})
      setTransactionId(0)
      setIsOpen(false)
  }

  const closeDialog = () => {
    setDialogObj({msg: '', id: 0})
    setDialogMsg("")
    setVoidDialog({open: false, transactionid: null, ticketid: null})
    setVoidTransactionConfirm(false)
    setVoidReason("")
    setVoidTicketReason("")
    setIsVoided(false)
    setVoidedBy('')
    setVoidedDate('')
    setVoidedComment('')
  }

  const voidTicket = async () => {
    try {
      await axios.post('/evtactivitytransactionsremoveticket', {
        eventid: eventId,
        transactionid: voidDialog.transactionid,
        ticketid: voidDialog.ticketid,
        comment: voidTicketReason
      })
      setVoidTicketReason("")
      setVoidDialog({open: false, transactionid: null, ticketid: null})
      getTransactionData(false)
    } catch {
      setVoidTicketReason("")
      setVoidDialog({open: false, transactionid: null, ticketid: null})
      setDialogMsg('Failed to void ticket. Please try again.')
    }
  }

  const confirmVoidTransaction = async () => {
    setVoidTransactionConfirm(false)
    setVoidReason("")
    setLoading(true)
    try {
      await axios.put('/evtactivitytransactionsvoid', { eventid: eventId, transactionid, comment: voidReason })
      queryClient.invalidateQueries(['EventTransaction', Number(eventId)])
      setItemQuantity({})
      setTransactionId(0)
      setIsOpen(false)
    } catch {
      setDialogMsg('Failed to void transaction. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  const handleEdit = (params: GridCellParams) => {
    setTicketId(params.row.ticketid)
    // getEventTicket(params.row.ticketid)
    setIsGuestOpen(true)
  }

  const clickVoidButton = (params: GridCellParams) => {
    // console.log(params)
    setVoidDialog({open: true, ticketid: params.row.ticketid, transactionid: transactionid})
  }

  const columns = [
    {
      field: 'Edit',
      disableExport: true,
      width: 80,
      sortable: false,
      renderCell: (params) => (
          <>
              {params.row.ticketcanremove &&
                <IconButton className={styles.button} onClick={() => { handleEdit(params) }}>
                  <Edit />
                </IconButton>
              }
          </>
      )
    },
    {
      field: 'guestname',
      type: 'string',
      headerName: 'Guest Name',
      minWidth: 300
    },
    {
      field: 'groupname',
      type: 'string',
      headerName: 'Group Name',
      minWidth: 300
    },
    {
      field: 'ticket',
      type: 'string',
      headerName: 'Ticket',
      minWidth: 300,
      cellClassName: (params: GridCellParams<number>) =>
          clsx('voided-row'),
    },
    {
      field: 'void',
      headerName: 'Status',
      disableExport: true,
      minWidth: 180,
      sortable: false,
      renderCell: (params: any) => (
          <>
            {params.row.ticketcanremove &&
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => clickVoidButton(params)}
                >
                  Void
                </Button>
            }
            {params.row.ticketremovedcomment?.length > 0 &&
                <span style={{
                  backgroundColor: '#c62828',
                  color: '#fff',
                  borderRadius: '12px',
                  padding: '2px 10px',
                  fontSize: '11px',
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                  letterSpacing: '0.4px',
                  textTransform: 'uppercase',
                }}>
                  Voided
                </span>
            }
          </>
      )
    },
  ]

  return (
    <>
      <Dialog open={isOpen} maxWidth="xl" fullWidth={true} className={styles.dialog}>
        <DialogTitle>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {title}
            {canVoid && !isVoided && (
              <IconButton size="small" onClick={(e) => setKebabAnchor(e.currentTarget)}>
                <MoreVertIcon />
              </IconButton>
            )}
          </div>
        </DialogTitle>
        {canVoid && !isVoided && (
          <Menu
            anchorEl={kebabAnchor}
            open={Boolean(kebabAnchor)}
            onClose={() => setKebabAnchor(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem
              onClick={() => { setKebabAnchor(null); setVoidTransactionConfirm(true) }}
              style={{ color: '#d32f2f' }}
            >
              <DeleteOutlineIcon fontSize="small" style={{ marginRight: 8 }} />
              Void Transaction
            </MenuItem>
          </Menu>
        )}
        {/*<LoadingBackdrop open={createMutation.isLoading || loading} />*/}
        <>
          <Dialog
              open={dialogMsg.length > 0}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {dialogMsg}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={closeDialog}>Ok</Button>
            </DialogActions>
          </Dialog>
        </>
        <>
          <Dialog open={voidDialog.open} maxWidth="sm" fullWidth>
            <DialogTitle style={{ paddingBottom: '8px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: 40, height: 40, borderRadius: '50%',
                  backgroundColor: '#fce4ec', flexShrink: 0
                }} />
                <span style={{ fontWeight: 600 }}>Void this ticket?</span>
              </div>
            </DialogTitle>
            <DialogContent>
              <Typography variant="body2" style={{ marginBottom: '12px' }}>
                If you void this ticket, it will not refund the purchaser. All refunds must be done using the payment processor's portal. Refunded amounts will not be reflected in EventSnap.
              </Typography>
              <Typography variant="body2" style={{ marginBottom: '20px' }}>
                Voiding this ticket will permanently disable it and add one ticket back to the available tickets pool. It will remain visible in this purchase record with the Voided label for your records.
              </Typography>
              <Typography variant="body2" style={{ fontWeight: 600, marginBottom: '6px' }}>
                Reason for voiding <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <TextField
                multiline
                rows={3}
                fullWidth
                variant="outlined"
                placeholder="Example: Guest could not attend; refund processed via Stripe on 04/14."
                value={voidTicketReason}
                onChange={(e) => setVoidTicketReason(e.target.value)}
              />
            </DialogContent>
            <DialogActions style={{ padding: '12px 24px' }}>
              <Button onClick={closeDialog} variant="outlined">Cancel</Button>
              <Button
                onClick={voidTicket}
                variant="contained"
                disabled={!voidTicketReason.trim()}
                style={{ backgroundColor: voidTicketReason.trim() ? '#9b2335' : undefined, color: voidTicketReason.trim() ? '#fff' : undefined }}
              >
                Void ticket
              </Button>
            </DialogActions>
          </Dialog>
        </>
        <>
          <Dialog open={voidTransactionConfirm} maxWidth="sm" fullWidth>
            <DialogTitle style={{ paddingBottom: '8px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: 40, height: 40, borderRadius: '50%',
                  backgroundColor: '#fce4ec', flexShrink: 0
                }} />
                <span style={{ fontWeight: 600 }}>Void this transaction?</span>
              </div>
            </DialogTitle>
            <DialogContent>
              <div style={{
                backgroundColor: '#fdf6e8',
                borderLeft: '4px solid #c8921a',
                borderRadius: '4px',
                padding: '12px 16px',
                marginBottom: '16px',
              }}>
                <Typography variant="body2">
                  <strong>This does not refund any money.</strong> All refunds must be processed outside of EventSnap.
                </Typography>
              </div>

              <Typography variant="body2" style={{ marginBottom: '8px' }}>
                When you void this transaction:
              </Typography>
              <ul style={{ margin: '0 0 8px 0', paddingLeft: '20px' }}>
                <li><Typography variant="body2">Tickets and merchandise return to the quantities available for purchase</Typography></li>
                <li><Typography variant="body2">Items are removed from all reporting</Typography></li>
                <li><Typography variant="body2">Items will not integrate with DonorSnap</Typography></li>
                <li><Typography variant="body2">Any groups and guest records created will still exist, but the tickets belonging to them will no longer exist</Typography></li>
              </ul>
              <Typography variant="body2" style={{ fontStyle: 'italic', color: '#666', marginBottom: '20px' }}>
                Empty groups and guests can be deleted from the maintenance pages as needed.
              </Typography>

              <Typography variant="body2" style={{ fontWeight: 600, marginBottom: '6px' }}>
                Reason for voiding <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <TextField
                multiline
                rows={3}
                fullWidth
                variant="outlined"
                placeholder="Example: Customer purchased duplicate ticket by mistake; refund processed via Stripe on 04/14."
                value={voidReason}
                onChange={(e) => setVoidReason(e.target.value)}
              />
              <Typography variant="caption" style={{ color: '#666', marginTop: '4px', display: 'block' }}>
                This note will be visible on the transaction record.
              </Typography>
            </DialogContent>
            <DialogActions style={{ padding: '12px 24px' }}>
              <Button onClick={closeDialog} variant="outlined">Cancel</Button>
              <Button
                onClick={confirmVoidTransaction}
                variant="contained"
                disabled={!voidReason.trim()}
                style={{ backgroundColor: voidReason.trim() ? '#9b2335' : undefined, color: voidReason.trim() ? '#fff' : undefined }}
              >
                Void transaction
              </Button>
            </DialogActions>
          </Dialog>
        </>
        <DialogContent>

          {(isVoided || ticketList?.some(t => t.ticketremovedcomment?.length > 0)) && (
            <div style={{
              backgroundColor: '#fdf0f0',
              borderLeft: '4px solid #c62828',
              borderRadius: '4px',
              padding: '12px 16px',
              marginBottom: '16px',
            }}>
              <Typography variant="body2">
                <strong>Transaction voided</strong>
                {voidedBy && (
                  <span style={{ color: '#666', fontWeight: 400 }}>
                    {' '}by {voidedBy}
                    {voidedDate && (
                      <> · {dayjs(voidedDate).format('MM/DD/YYYY hh:mm A')}</>
                    )}
                  </span>
                )}
              </Typography>
              {voidedComment && (
                <Typography variant="body2" style={{ marginTop: '4px' }}>
                  <strong>Reason:</strong><br />
                  {voidedComment}
                </Typography>
              )}
            </div>
          )}

          <Grid container spacing={1} style={{marginTop: '5px'}}>
            <Grid item xs={12} className={styles.selectcontrol}>
              <b>Items:</b>
            </Grid>
            {transactionData?.itemdetail?.length == 0 &&
            <Grid item xs={12} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin'}} >No Items</InputLabel>
            </Grid>
            }
          </Grid>
            {transactionData?.itemdetail?.map((cd) => (
                <Grid container style={{marginTop: '5px'}} >
                  <Grid item xs={6} className={styles.selectcontrol}>
                    {cd.transactiondetailitemname}
                  </Grid>
                  <Grid item xs={6} className={styles.selectcontrol}>
                    <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} >{cd.transactiondetailqty + ' x ' + formatMoney(cd.transactiondetailprice) + ' = ' + formatMoney(cd.transactiondetaillinetotal)}</InputLabel>
                  </Grid>
                </Grid>
            ))}

          <Grid container spacing={1} style={{marginTop: '15px', marginBottom: '15px', borderTop: '1px solid #eeeeee'}}>
            <Grid item xs={9} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} ><b>Subtotal:&nbsp;</b></InputLabel>
            </Grid>
            <Grid item xs={3} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} >{formatMoney(transactionData.transactionsubtotal | 0)} ({transactionData?.itemdetail?.length | 0} items)</InputLabel>
            </Grid>
          </Grid>
          <Grid container spacing={1} style={{marginTop: '5px'}}>
            <Grid item xs={6} className={styles.selectcontrol}>
              <b>Customer Information:</b>
              {/*<InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin'}} ><b>Customer Information:</b></InputLabel>*/}
            </Grid>
            <Grid item xs={3} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} ><b>CC Fees:&nbsp;</b></InputLabel>
            </Grid>
            <Grid item xs={3} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} >{formatMoney(transactionData.transactionprocessingfees)}</InputLabel>
            </Grid>
          </Grid>
          <Grid container spacing={1} style={{marginTop: '5px'}}>
            <Grid item xs={6} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin'}} >{transactionData.transactionfirst + ' ' + transactionData.transactionlast}</InputLabel>
            </Grid>
            <Grid item xs={3} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} ><b>Discount:&nbsp;</b></InputLabel>
            </Grid>
            <Grid item xs={3} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} >{formatMoney(transactionData.transactiondiscountamount)}</InputLabel>
            </Grid>
          </Grid>
          <Grid container spacing={1} style={{marginTop: '5px'}}>
            <Grid item xs={6} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin'}} >{transactionData.transactionaddress + ' ' + transactionData.transactioncity + ' ' + transactionData.transactionstate + ' ' + transactionData.transactionzip}</InputLabel>
            </Grid>
            <Grid item xs={3} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} ><b>Additional Donation:&nbsp;</b></InputLabel>
            </Grid>
            <Grid item xs={3} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} >{formatMoney(transactionData.transactionadditionaldonation)}</InputLabel>
            </Grid>
          </Grid>
          <Grid container spacing={1} style={{marginTop: '5px'}}>
            <Grid item xs={6} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin'}} >{transactionData.transactionemail}</InputLabel>
            </Grid>
            <Grid item xs={3} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} ><b>Total:&nbsp;</b></InputLabel>
            </Grid>
            <Grid item xs={3} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} >{formatMoney(transactionData.transactiontotalamount)}</InputLabel>
            </Grid>
          </Grid>
          <Grid container spacing={1} style={{marginTop: '5px'}}>
            <Grid item xs={9} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} ><b>Payment Method:&nbsp;</b></InputLabel>
            </Grid>
            <Grid item xs={3} className={styles.selectcontrol}>
              <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} >{transactionData.transactionpaymentmethod}</InputLabel>
            </Grid>
          </Grid>

          <Grid container spacing={1} style={{marginTop: '5px'}}>
            <Grid item xs={12} className={styles.selectcontrol}>
              <b>Guest Registration:</b>
            </Grid>
          </Grid>
          <Grid container spacing={1} style={{marginTop: '5px'}}>
            {ticketList && ticketList.length > 0 &&
                <DataGridPremium
                    autoHeight
                    rows={ticketList}
                    columns={columns}
                    loading={false}
                    pagination={false as any}
                    getRowClassName={(params) =>
                        params.row.ticketremovedcomment?.length > 0 ? styles['voided-row'] : ''
                    }
                    // sx={{
                    //   '& .MuiDataGrid-row.Mui-selected': {
                    //     backgroundColor: 'rgba(238,3,79,0.1)', // Example: light blue with transparency
                    //     '&:hover': {
                    //       backgroundColor: 'rgba(255,0,59,0.2)', // Example: slightly darker on hover
                    //     },
                    //   },
                    // }}
                />
            }
          </Grid>
          <GenericForm isGuestOpen={isGuestOpen} setIsGuestOpen={setIsGuestOpen} endpoint={'evtticket'} eventId={eventId} genericid={ticketId} />
        </DialogContent>
        <DialogActions>
          <Button
              variant="contained"
              className={styles.submitButton}
              type="submit"
              onClick={() => {onSubmit()}}
              form="items-form">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
